var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('detection-detail-component',{attrs:{"detection-type":'detectionDetail',"detectionKey":_vm.detectionKey}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }